module.exports = __webpack_public_path__ + "static/vf_wpants3_core.980ee65d.svg";